module.exports = __webpack_public_path__ + "media/step1_animation_Brueche.04f21a1c.webm";